// extracted by mini-css-extract-plugin
export default {"container":"allrewardsused_container__NhKXe","img":"allrewardsused_img__Hzd6f"};